import { Link } from '@tanstack/react-router';
import { Calendar, ChevronRight, Stethoscope, User } from 'lucide-react';
import { Card, CardContent, Badge } from '@/components/ui';
import {
  classificarProcedimento,
  formatarData,
  iniciais,
} from '@/lib/utils';
import type { ClinusAtendimento, ClinusPaciente } from '@/types/api';

interface Props {
  consulta: ClinusAtendimento;
  paciente?: ClinusPaciente;
}

export function AtendimentoCard({ consulta, paciente }: Props) {
  const tipo = classificarProcedimento(consulta.dsProcedimento);

  return (
    <Link
      to="/pep-vida/atendimentos/$cdAtendimento"
      params={{ cdAtendimento: String(consulta.cdAtendimento) }}
      className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg"
    >
      <Card
        variant={tipo}
        className="transition-colors hover:bg-accent/40"
        data-testid="atendimento-card"
      >
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-sm font-semibold">
              {iniciais(paciente?.ds_paciente)}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <p className="truncate font-medium" title={paciente?.ds_paciente}>
                  {paciente?.ds_paciente || `Paciente #${consulta.cdPaciente}`}
                </p>
                <Badge variant={tipo} className="shrink-0">
                  {tipo}
                </Badge>
              </div>

              <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
                <span className="inline-flex items-center gap-1">
                  <Calendar className="h-3 w-3" />
                  {formatarData(consulta.dtData)}
                </span>
                {consulta.dsMedico && (
                  <span className="inline-flex items-center gap-1">
                    <User className="h-3 w-3" />
                    {consulta.dsMedico}
                  </span>
                )}
                {consulta.dsProcedimento && (
                  <span className="inline-flex items-center gap-1">
                    <Stethoscope className="h-3 w-3" />
                    {consulta.dsProcedimento}
                  </span>
                )}
              </div>
            </div>
            <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
